<template>
  <SwitchGroup as="div" class="flex items-center">
    <slot name="left">
      <PfIcon v-if="props.iconLeft" :icon="props.iconLeft" class="mr-2.5" :class="iconColorClass" aria-hidden="true" />
    </slot>
    <Switch
      :model-value="modelValue"
      :class="[
        'bg-primary-500',
        'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent ring-primary-shade ring-offset-white transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 dark:ring-white dark:ring-offset-primary-shade'
      ]"
      @update:model-value="(v) => emit('update:modelValue', v)">
      <span
        aria-hidden="true"
        :class="[
          'bg-white',
          modelValue ? 'translate-x-5' : 'translate-x-0 ',
          'pointer-events-none inline-block h-5 w-5 rounded-full shadow ring-0 transition duration-200 ease-in-out'
        ]" />
    </Switch>
    <SwitchLabel v-if="props.label || $slots.rightLabel" as="span" class="flex items-center">
      <slot name="right">
        <PfIcon v-if="props.iconRight" class="ml-2.5" :class="iconColorClass" :icon="props.iconRight" aria-hidden="true" />
        <span v-if="props.label" class="ml-5" :class="{ 'sr-only': showIconOnly }">
          <span class="block text-sm font-medium text-grey-900 dark:text-grey-200">{{ props.label }}</span>
          <span v-if="props.description" class="block text-sm text-grey-500 dark:text-grey-400">{{ props.description }}</span>
        </span>
      </slot>
    </SwitchLabel>
  </SwitchGroup>
</template>

<script setup>
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";

const props = defineProps({
  label: {
    type: String,
    default: ""
  },
  description: {
    type: String,
    default: ""
  },
  iconLeft: {
    type: Object,
    default() {
      return null;
    }
  },
  iconRight: {
    type: Object,
    default() {
      return null;
    }
  },
  iconColorClass: {
    type: String,
    default: "text-grey-500"
  },
  showIconOnly: Boolean,
  modelValue: Boolean
});

const emit = defineEmits(["update:modelValue"]);
</script>
